/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2014 (original work) Open Assessment Technologies SA (under the project TAO-PRODUCT);
 */

define('taoQtiItem/qtiCreator/renderers/Object',[
    'lodash',
    'taoQtiItem/qtiCommonRenderer/renderers/Object',
    'taoQtiItem/qtiCreator/widgets/static/object/Widget'
], function(_, Renderer, Widget){
    'use strict';

    var CreatorObject = _.clone(Renderer);

    CreatorObject.render = function(object, options){

        //initial rendering:
        Renderer.render(object);

        options = options || {};
        options.baseUrl = this.getOption('baseUrl');
        options.uri = this.getOption('uri');
        options.lang = this.getOption('lang');
        options.mediaManager = this.getOption('mediaManager');
        options.assetManager = this.getAssetManager();

        Widget.build(
            object,
            Renderer.getContainer(object),
            this.getOption('bodyElementOptionForm'),
            options
        );
    };

    return CreatorObject;
});

